import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz-', 21);
import { ValidationService } from '../../services/validation.service';
import { ManagementArea } from '../area-models/management-area.model';
import { SharedMethodsService } from '../../services/shared-methods.service';

export class StartReport {

  startDate: Date = new Date(); // same as start date in trip model

  managementArea: ManagementArea = new ManagementArea();

  reportID: string = '';

  internalId: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // date the report was completed within the app

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  comments: string = ''; // optional

  vesselMasterAgreement: boolean = false; // flag that tells us if the vessel master agreement has been signed by the user

  /* Flags for programmatical use */

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  isComplete: boolean = false; // flag that tells us if the report has been completed

  constructor() {

    this.internalId = 'id-' + nanoid();
    this.reportID = SharedMethodsService.generateReportID("S");

  }

  public isValid(): boolean {
    return this.isComplete && !!this.managementArea;
  }

  public toString(): string {
    return 'Start Date: ' + this.startDate + '; Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's Start Fishing Report is defined
  public static transformAnonymous(startReport: any): StartReport {

    // if it is not defined, set a new one
    if (!startReport) {
      return new StartReport();
    }

    let userStartReport: StartReport = new StartReport();
    userStartReport.startDate = ValidationService.validateDate(startReport.startDate);
    userStartReport.managementArea = ManagementArea.transformAnonymous(startReport.managementArea);
    userStartReport.confirmationNumber = startReport.confirmationNumber ?? '';
    userStartReport.emailedAt = startReport.emailedAt ?? '';
    userStartReport.completionDate = ValidationService.validateDate(startReport.completionDate);
    userStartReport.submissionDate = ValidationService.validateDate(startReport.submissionDate);
    userStartReport.comments = startReport.comments ?? '';
    userStartReport.reportID = startReport.reportID;
    userStartReport.internalId = startReport.internalId
    userStartReport.isComplete = startReport.isComplete ?? false;
    userStartReport.isSubmitted = startReport.isSubmitted ?? false;
    userStartReport.vesselMasterAgreement = startReport.vesselMasterAgreement ?? false;
    return userStartReport;

  }

}
